import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  addSale (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  UpdateSale (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/update', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  holdBill (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/holdbill', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  openShift (URL, body, header, success, error) {
    Vue.axios.post(URL + 'company/v1/shift/open', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  closeShift (URL, body, header, success, error) {
    Vue.axios.post(URL + 'company/v1/shift/close', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  closeShiftUpdate (URL, body, header, success, error) {
    Vue.axios.post(URL + 'company/v1/shift/update', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getHostShift (URL, header, success, error) {
    Vue.axios.get(URL + 'company/v1/host/list', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getHostShiftDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/shift/details', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  billList (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  billPosList (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/history/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  printBill (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/cash/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  printHolding (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/hold/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  printBillCredit (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/credit/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  printPaybill (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSaleOnHost (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/report/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  cancelBill (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/cancel', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getHoldingBill (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/holdbill/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ExportMoney (URL, body, header, success, error) {
    Vue.axios.post(URL + 'company/v1/shift/expense/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ImportMoney (URL, body, header, success, error) {
    Vue.axios.post(URL + 'company/v1/shift/income/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  PrintCloseShif (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/shift/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  openCashBox (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/open/cashbox', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  receiveList (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/creditnote/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  receiveCancel (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/creditnote/cancel', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  receiveById (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/creditnote/id', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  billCreditList (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/bill/receipt/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  receiveNew (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/creditnote/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  receiveUpdate (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/creditnote/update', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  receiptSearch (URL, body, header, success, error) {
    Vue.axios.post(URL + 'customer/v1/receipt/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  receiptDetail (URL, body, header, success, error) {
    Vue.axios.post(URL + 'customer/v1/receipt/id', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  receiptDel (URL, body, header, success, error) {
    Vue.axios.post(URL + 'customer/v1/receipt/cancel', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  payBillCredit (URL, body, header, success, error) {
    Vue.axios.post(URL + 'customer/v1/receipt/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  printPayBillCredit (URL, body, header, success, error) {
    Vue.axios.post(URL + 'customer/v1/receipt/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPosByDoc (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPosList (URL, body, header, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/return/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  configDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/branch/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  billCreditDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/print/data', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  billReceiptDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'customer/v1/receipt/id', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  slipExpend (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/expense/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  slipIncome (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/income/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  checkReturn (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/check/return', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  changeSlip (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/change/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  checkOpenShift (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/shift/open/now', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_pos.js